let vueUtils = {}
let __ob__ = '__ob__'
/**
获取数组指定属性拼接为用特定符号连接的字符串
 * @param {array} arr 数组
 * @param {String} paramName 指定连接的属性名
 * @param {String} separator 特定符号
*/
vueUtils.removeOB = function (object) {
  if (null == object) return
  if (object.__ob__) delete object.__ob__

  if (object instanceof Array) {
    object.forEach(function (val, index) {
      //  console.log("Array",index);
      vueUtils.removeOB(val)
    })
  } else if (object instanceof Object) {
    Object.keys(object).forEach(function (key) {
      //  console.log("object[key]",key);
      vueUtils.removeOB(object[key])
    })
  }
}

/**
*crudEdit 使用后，能在关闭时候，释放一定内容。
200条数据。48.5M 较少到 40.5M  （减少8M）
*/
vueUtils.removeAtt = function (object) {
  if (null === object) return

  if (Object.isFrozen(object)) {
    return
  }

  if (object instanceof Array) {
    object.forEach(function (val, index) {
      //  console.log("Array",index);
      object.pop()
      vueUtils.removeAtt(val)
      // delete object[index];
    })
    // console.log("object.length",object.length);
    object.length = 0
    // console.log("object.length2",object.length);
  } else if (object instanceof Object) {
    Object.keys(object).forEach(function (key) {
      //  console.log("object[key]",key);
      vueUtils.removeAtt(object[key])

      delete object[key]
    })
  }

  if (object && object.__ob__) delete object.__ob__

  //  console.log("!Object.isFrozen(object)",object);
}

export default vueUtils
